import { useEffect } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import useAPI from '../../../api';
import useNotify from '../../../Hooks/useNotify';
import { endedCallDataAtom, selectedBranchAtom } from '../../../Atoms';

/**
 * Sends an email from the branch's SMTP address, and the email part of an end-call message as soon
 * as `endCallMessage` asks for one. Returns the submit handler of the email window.
 */
const useSendEmail = function useSendEmail({
  selectedEmailAddress = null,
  endCallMessage = null,
  setEndCallMessage = () => {},
  setSendEndCallMessage = () => {},
  onClose = () => {},
}) {
  const API = useAPI();
  const selectedBranch = useAtomValue(selectedBranchAtom);
  const { notify } = useNotify();
  const [endedCallData, setEndedCallData] = useAtom(endedCallDataAtom);

  const handleSendEmail = (submitData, isSms) => {
    const formData = new FormData();

    formData.append('receiver', submitData?.receiver);
    formData.append('subject', submitData?.subject);
    formData.append('body', submitData?.body);
    formData.append('replyAll', submitData?.replyAll);

    if (submitData?.parentActivityId)
      formData.append('parentActivityId', submitData?.parentActivityId);
    if (selectedBranch?.smtp) formData.append('sender', selectedBranch.smtp);
    if (submitData?.cc && submitData?.cc.length > 0)
      formData.append('cc', submitData?.cc);
    if (submitData?.bcc && submitData?.bcc.length > 0)
      formData.append('bcc', submitData?.bcc);
    if (submitData?.inReplyTo)
      formData.append('inReplyTo', submitData?.inReplyTo);
    if (submitData?.files?.length)
      submitData.files.forEach((file) => formData.append('files', file));

    if (formData.get('sender')) {
      API.sendEmail(
        formData,
        { doNotStringify: true },
        () => {
          notify('SUCCESS_EMAIL', 'success');
          onClose();
          if (isSms !== null) {
            setEndedCallData(null);
            setEndCallMessage(null);
            setSendEndCallMessage(false);
          }
        },
        () => {
          notify('ERROR_EMAIL', 'error');
          setSendEndCallMessage(false);
        }
      );
    }
  };

  useEffect(() => {
    if (endCallMessage) {
      if (
        (endCallMessage?.channel === 'BOTH' ||
          endCallMessage?.channel === 'EMAIL') &&
        endCallMessage?.emailBody
      ) {
        if (selectedBranch?.smtp && endCallMessage?.emailBody)
          handleSendEmail(
            {
              receiver: selectedEmailAddress,
              sender: selectedBranch?.smtp,
              subject: endCallMessage?.emailSubject,
              body: endCallMessage?.emailBody,
              parentActivityId: endedCallData.id,
            },
            endCallMessage?.channel === 'BOTH'
          );
      }
    }
  }, [endCallMessage]);

  return handleSendEmail;
};

export default useSendEmail;
